import React, { useEffect, useState } from "react";
import { Tabs, Tab, Grid, Box } from "@material-ui/core";
import { createTheme, ThemeProvider } from "@material-ui/core/styles";
import styled from 'styled-components';
import Text from "../../typography";
import propTypes from 'prop-types';
import { theme } from "../../../themes/default-theme";
import RespImg from "../../ui/RespImg";
import NewRadio from "../../forms/NewRadio";

const Wrapper = styled.div`
    ${props => props.background && `
        background: ${props.background == "black" ? '#282828;' : props.background == "grey" ? theme.palette.lightGrey : props.background == "black" ? "#282828" : props.background};
    `}
    ${props => (props.background == "grey" || props.background == "white") ? `
        * {
            color: ${theme.palette.charcoal}
        }
        `: `
        * {
            color: ${theme.palette.white}
         }
    `}
`

const TitleContainer = styled.div`
    
    h4 {
        margin-bottom: 12px;
        font-weight: 700;
        font-size: 14px;
        line-height: 19px;
        text-align: center;
        letter-spacing: 1px;
        text-transform: uppercase;
        color: ${theme.palette.vividBlue};
    }
    h2 {
        margin-bottom: 39px;
        font-weight: 800;
        font-size: 34px;
        line-height: 38px;
        text-align: center;
        text-transform: uppercase;
        max-width: 815px;
        margin-left: auto;
        margin-right: auto;
    }
    
    ${theme.breakpoints.down('sm')} {
   
    h4 {
        margin-bottom: 10px;
        font-weight: 700;
        font-size: 12px;
        line-height: 16px;
        text-align: center;
        letter-spacing: 1px;
        text-transform: uppercase;
        color: #0170D4;
    }
    h2 {
        margin-bottom: 32px;
        font-weight: 800;
        font-size: 18px;
        line-height: 24px;
        text-align: center;
        text-transform: uppercase;
    }
}
`

const Container = styled.div`
    ${theme.breakpoints.down('sm')} {
        padding: 52px 20px;
    }
    h2 {
        max-width: 815px;
        margin-left: auto;
        margin-right: auto;
    }
    ${theme.breakpoints.up('md')} {
        padding: 64px 0 64px;
    }
`

const TabsContainer = styled.div`
    ${theme.breakpoints.up('md')} {
        > div {
            &:first-child {
                 margin-bottom: 49px;
            }
        }
    }
    ${theme.breakpoints.down('sm')} {
        > div {
            &:first-child {
                 margin-bottom: 35px;
            }
        }
    }
`
const TabsContent = styled.div`
    ${theme.breakpoints.up('lg')} {
        display: flex;
        justify-content: center;
        width: 100%;
        max-width: 1445px;
        margin-left: auto;
        margin-right: auto;
    }
    
`
const TabContent = styled.div`
    position: relative;
    transition: opacity 400ms ease-in-out;
    ${props => !props.visible ? `
        opacity: 0;
        visibility: hidden;
        z-index: -10000;
        position: fixed;
        left: -10000px;
        top: -10000px;
    ` : `
        opacity: 1;
        visibility: visible;
        z-index: initial;
    `}
    ${theme.breakpoints.up('lg')} {
        display: flex;
        align-items: center;
        width: 100%;
    }
`
const TabContentSelections = styled.div`
    ${props => props.background && `
        background: ${props.background == "black" ? '#282828;' : props.background == "grey" ? theme.palette.lightGrey : props.background};
        color: ${props.background == "black" ? theme.palette.white : "#282828"};
    `}

    ${theme.breakpoints.up('md')} {
        position: relative;
        bottom: 0;
        right: 0;
        padding: 36px 20px 18px;
        width: 100%;
    }

    ${theme.breakpoints.up('lg')} {
        padding: 36px 54px 18px;
        max-width: 580px;
    }
`
const ActiveImageContainer = styled.div`
    width: 100%;
`
const ActiveImage = styled.div`
    display: none;
    position: relative;
    height: 0;
    padding-top: 71%;
    width: 100%;

    img,
    picture {
        position: absolute;
        height: 100%;
        width: 100%;
        left: 50%;
        top 50%;
        object-fit: cover;
        transform: translate(-50%, -50%);
    }

    &:first-child {
        display: block;
    }
`

const SelectionContainer = styled.div`
    ${theme.breakpoints.down('md')} {
        display: inline-table;
        margin-top: 30px;
    }
    ${props => props.length > 3 ? `
        width: 100%;
    `: `
        margin-right: 46px;
    `}
`
const DecorTitles = styled.div`
    ${theme.breakpoints.up('md')} {
        h3 {
            font-weight: 800;
            font-size: 14px;
            line-height: 18px;
            text-transform: uppercase;
        }
    }
    ${theme.breakpoints.down('sm')} {
        h3 {
            font-weight: 800;
            font-size: 12px;
            line-height: 18px;
            text-transform: uppercase;
            margin-bottom: 4px;
        }
    }
`
const DecorModelTitles = styled.div`
    ${theme.breakpoints.up('md')} {
        h4 {
            font-weight: 400;
            font-size: 16px;
            line-height: 22px;
            margin-bottom: 16px;
            text-transform: capitalize;
            margin-top: 5px;
        }
    }
    ${theme.breakpoints.down('sm')} {
        h4 {
            font-weight: 400;
            font-size: 12px;
            line-height: 22px;
            margin-bottom: 12px;
            text-transform: capitalize;
        }
    }
`
const Selections = styled.div`
    margin-bottom: 20px;
    margin-left: -4px;
    margin-right: -4px;
    flex-wrap: wrap;

    picture,
    img {
        max-width: 75px;
    }
    ${theme.breakpoints.up('md')} {
        display: flex;
        gap: 18px;
        label {
            > span {
                padding: 0.04rem;
            }
        }
    }
    ${theme.breakpoints.down('sm')} {
        display: flex;
        gap: 15px;
    }
`

const InteriorDecorModule = (props) => {

    const {
        background,
        pretitle,
        title,
        data
    } = props;

    // Data Updates Start
    data.map((element, i) => {
        element.selected = [];
        element.decorTitles.map((item, index) => {
            element.selected[index] = element.decorTitles[index].decor[0].id;
        })
    });
    // Data Updates End

    // States Start
    const [tabvalue, setTabValue] = useState(0);
    const [models, setModels] = useState(data);
    const [activeAsset, setActiveAsset] = useState([]);
    const [activeDecor, setActiveDecor] = useState([]);
    const [selectedModels, setSelectedModels] = useState(models.map((item) => item.selected));
    // States End


    // Tabs Style Start
    const theme = (theme) => createTheme({
        overrides: {
            MuiTabs: {
                indicator: {
                    background: "none"
                }
            },
            MuiTab: {
                root: {
                    "&.Mui-selected": {
                        background: "#0170D4",
                        border: "none",
                    },
                    "&:not(.Mui-selected)": {
                        border: "1px solid #575757",
                        background: background == 'grey' ? 'inherit' : background == 'black' ? "inherit" : theme.palette.white,
                        opacity: "1"

                    },
                    "&:nth-child(odd)": {
                        borderRadius: '8px 0px 0px 8px'

                    },
                    "&:nth-child(even)": {
                        borderRadius: '0px 8px 8px 0px'
                    },
                },
                wrapper: {
                    "button:not(.Mui-selected) &": {
                        color: background == 'black' || background == '#000' ? "#fff" : "#282828"
                    },
                    "button.Mui-selected &": {
                        color: theme.palette.white
                    },
                    [theme.breakpoints.up('md')]: {
                        fontSize: "17px",
                        lineHeight: "23px"
                    },
                    [theme.breakpoints.down('sm')]: {
                        fontSize: "12px",
                        lineHeight: "16px"
                    }
                }
            }
        }
    });
    // Tabs Style End

    // Methods Start
    let checkSubset = (parentArray, subsetArray) => {
        return subsetArray.every((el) => {
            return parentArray.includes(el)
        })
    }

    const handleTabsChange = (event, newValue) => {
        setTabValue(newValue);
    };
    const radioChangeHandler = (i, parentItemIndex, e) => {
        const newState = models.map((model, index) => {
            model.selected.map((child, modelIndex) => {
                if (parentItemIndex == modelIndex) {
                    return (
                        selectedModels[i][modelIndex] = e.target.value
                    )
                }
                return child;
            })
            return model;
        })
        setModels(newState)
    }
    // Methods End
    useEffect(() => {
        const assetsArr = [];
        models.map((parentItem, i) => {
            return (
                parentItem.assets.map((asset, index) => checkSubset(asset.selection.map(function (obj) {
                        return (obj.id).toString().toLowerCase()
                    }), selectedModels[i].map((item) => item.toString().toLowerCase())) &&
                        (assetsArr[i] = asset.image) 
                )
            )
        })
        
        setActiveDecor(models && models.length > 0 && models.map((parentItem, i) => {
            return (
                parentItem.decorTitles.map((parent, parentIndex) => {
                    return (
                        parent.decor.filter((child, childIndex) => {
                            if(selectedModels[i][parentIndex].toString().toLowerCase() == (child.id.toString().toLowerCase())) {
                                return child
                            }
                        })
                    )
                }) 
            )
        }))

        setActiveAsset(assetsArr)
    }, [models, selectedModels])

    console.log('interiordecormodule', props);

    return (
        <>
            {data && data.length > 0 &&
                <Wrapper background={background ? background : "#fff"}>
                    <Container>
                        <Grid className="hasPadding" container>
                            <Grid item xs={12}>
                                <Box px={2}>
                                    <TitleContainer>
                                        {pretitle &&
                                            <Text variant="subTitle" colour={"vividBlue"} element="h4" align="center">{pretitle}</Text>
                                        }
                                        {title &&
                                            <Text variant="h2" align="center">{title}</Text>
                                        }
                                    </TitleContainer>
                                </Box>
                            </Grid>
                        </Grid>
                        <ThemeProvider theme={theme}>
                            <TabsContainer>
                                {models.length > 1 &&
                                    <Tabs
                                        onChange={handleTabsChange}
                                        value={tabvalue}
                                        centered={true}
                                    >
                                        {models.map((item, index) => {
                                            return (
                                                <Tab key={index} label={item.category} />
                                            )
                                        })
                                        }
                                    </Tabs>
                                }
                                <TabsContent>
                                  {models && models.length > 0 &&
                                    models.map((parentItem, i) => {
                                        return (
                                     
                                            <TabContent visible={tabvalue == i} key={i}>
                                                {activeAsset && activeAsset[i] && Object.values(activeAsset[i]).length > 0 &&
                                                    <ActiveImageContainer>
                                                        <ActiveImage active="true" >
                                                            <RespImg
                                                                {...activeAsset[i]}
                                                                lazyLoad={false}
                                                            />
                                                        </ActiveImage>
                                                    </ActiveImageContainer>
                                                }
                                                {parentItem.decorTitles && parentItem.decorTitles.length > 0 &&
                                                    <TabContentSelections background={background}>
                                                        {parentItem.decorTitles.map((item, parentItemIndex) => {
                                                            return (
                                                                <SelectionContainer key={parentItemIndex} length={item.decor && item.decor.length}>
                                                                    <DecorTitles>
                                                                        <Text variant="h3" weight={800}>{item.title}</Text>
                                                                    </DecorTitles>
                                                                    <DecorModelTitles>
                                                                        <Text variant="h4" >{item.decor.map((selection) => { return ((selection.id.toString().toLowerCase()) == selectedModels[i][parentItemIndex].toString().toLowerCase() && selection.title) })}</Text>
                                                                    </DecorModelTitles>
                                                                    <Selections>
                                                                        {item.decor && item.decor.length > 0 &&
                                                                            item.decor.map((selection, index) => {
                                                                            return (
                                                                                <NewRadio
                                                                                    key={`${selection.id}${parentItemIndex}${index}`}
                                                                                    changed={(e) => radioChangeHandler(i, parentItemIndex, e)}
                                                                                    id={`${selection.id}${parentItemIndex}${index}`}
                                                                                    isSelected={selectedModels[i][parentItemIndex].toString().toLowerCase() == (selection.id.toString().toLowerCase())}
                                                                                    label={selection.title}
                                                                                    thumbnail={selection.image}
                                                                                    value={selection.id}
                                                                                />
                                                                            )
                                                                        })
                                                                        }
                                                                    </Selections>
                                                                </SelectionContainer>
                                                            )
                                                        })
                                                        }
                                                    </TabContentSelections>
                                                }
                                            </TabContent>
                                        )
                                    })
                                    }
                                </TabsContent>
                            </TabsContainer>
                        </ThemeProvider>
                    </Container>
                </Wrapper>
            }
        </>
    );
}

InteriorDecorModule.propTypes = {
    background: propTypes.string,
    pretitle: propTypes.string,
    title: propTypes.string,
    data: propTypes.array
}

InteriorDecorModule.defaultProps = {
    background: null,
    pretitle: null,
    title: null,
    data: []
}

export default InteriorDecorModule